import { createContext, useState } from "react";

const LabFormContext = createContext({})

export const LabFormProvider = ({children}:any)=>{
    const [online, setOnline] = useState(true)
    const [selectedId, setSelectedId] = useState('')

    return(
        <LabFormContext.Provider value={{online, setOnline, selectedId, setSelectedId}}>
            {children}
        </LabFormContext.Provider>
    )
}

export default LabFormContext